export const PARTNERSHIP_UI_TABS_OBJECT_TYPE_CODE = 10168;
export const PARTNERSHIP_UI_TABS_ATTRIBUTE_NAME = 'tog_type';
export const EG_WITH_SUC = '16a46724-9fcd-e011-87d5-0025b322d9d8';

export enum PartnershipTypeValue {
  DONOR_PARTNERSHIP_BILLING = 10000008,
  SPECIAL_BILLING = 100000009,
  BILL_ACCOUNT = 1000000010,
}

export enum PartnershipBillingType {
  DONOR_PARTNERSHIP = 100000000,
  SPECIAL_PARTNERSHIP = 100000001,
}

export const PartnershipTypeLabel = {
  [PartnershipTypeValue.DONOR_PARTNERSHIP_BILLING]: 'Donor Partnership Billing',
  [PartnershipTypeValue.SPECIAL_BILLING]: 'Special Billing',
  [PartnershipTypeValue.BILL_ACCOUNT]: 'Bill Account',
};

export enum BillingSplitType {
  FIFTY_FIFTY = '50_50',
  SEVENTY_FIVE_TWENTY_FIVE = '75_25',
  FIFTY_TWENTY_FIVE_TWENTY_FIVE = '50_25_25',
  TWENTY_FIVE_EACH = '25_25_25_25',
  THIRTY_THREE_EACH = '33_33_34',
  ONE_HUNDRED = '100',
}

export const BillingSplitLabel = {
  [BillingSplitType.FIFTY_FIFTY]: '50%/50%',
  [BillingSplitType.SEVENTY_FIVE_TWENTY_FIVE]: '75%/25%',
  [BillingSplitType.FIFTY_TWENTY_FIVE_TWENTY_FIVE]: '50% 25% 25%',
  [BillingSplitType.TWENTY_FIVE_EACH]: '25% 25% 25% 25%',
  [BillingSplitType.THIRTY_THREE_EACH]: '33% 33% 34%',
  [BillingSplitType.ONE_HUNDRED]: '100%',
};

export const BillingSplitPercentages = {
  [BillingSplitType.FIFTY_FIFTY]: [50, 50],
  [BillingSplitType.SEVENTY_FIVE_TWENTY_FIVE]: [75, 25],
  [BillingSplitType.FIFTY_TWENTY_FIVE_TWENTY_FIVE]: [50, 25, 25],
  [BillingSplitType.TWENTY_FIVE_EACH]: [25, 25, 25, 25],
  [BillingSplitType.THIRTY_THREE_EACH]: [33, 33, 34],
  [BillingSplitType.ONE_HUNDRED]: [100],
};

export const NULL_ACCOUNT_STATE = {
  account1: null,
  account2: null,
  account3: null,
  account4: null,
};

export const TWENTY_FIVE_PERCENT_STATE = {
  percent1: 25,
  percent2: 25,
  percent3: 25,
  percent4: 25,
};

export const THIRTY_THREE_PERCENT_STATE = {
  percent1: 33,
  percent2: 33,
  percent3: 34,
  percent4: null,
};

export const ONE_HUNDRED_PERCENT_STATE = {
  percent1: 100,
  percent2: null,
  percent3: null,
  percent4: null,
};
